const PermissionsMap = {
	REPORTS_CREATE: "krummy capture:reports:create",
	REPORTS_READ: "krummy capture:reports:read",
	REPORTS_UPDATE: "krummy capture:reports:update",
	REPORTS_DELETE: "krummy capture:reports:delete",
	REPORT_CREATION: "krummy capture:report creation",
	TEMPLATES_CREATE: "krummy capture:templates:create",
	TEMPLATES_READ: "krummy capture:templates:read",
	TEMPLATES_UPDATE: "krummy capture:templates:update",
	TEMPLATES_DELETE: "krummy capture:templates:delete",
	TOGGLE_PROPOSALS_BUTTON: "krummy capture:toggle proposals button",
	VIEW_PROPOSALS: "krummy capture:view proposals",
	EXPORT_BUTTON: "krummy capture:export button",
	CLEAR_RECORD_BUTTON: "krummy capture:clear record button",
	VIEW_CLOCKING_NOTES: "krummy capture:view clocking notes",
	WORD_BANK_CREATE: "krummy capture:word bank:create",
	WORD_BANK_READ: "krummy capture:word bank:read",
	WORD_BANK_UPDATE: "krummy capture:word bank:update",
	WORD_BANK_DELETE: "krummy capture:word bank:delete",
	CLOCKING_INFO: "ox2:clocking info",
	WAREHOUSES_CREATE: "ox2:warehouses:create",
	WAREHOUSES_READ: "ox2:warehouses:read",
	WAREHOUSES_UPDATE: "ox2:warehouses:update",
	WAREHOUSES_DELETE: "ox2:warehouses:delete",
	TICKET_ALERTS: "ox2:ticket alerts",
	VEHICLE_MOVEMENT_ALERTS: "ox2:vehicle movement alerts",
	RBAC_PROJECTS_CREATE: "ox2:rbac projects:create",
	RBAC_PROJECTS_READ: "ox2:rbac projects:read",
	RBAC_PROJECTS_UPDATE: "ox2:rbac projects:update",
	RBAC_PROJECTS_DELETE: "ox2:rbac projects:delete",
	RBAC_ROLES_CREATE: "ox2:rbac roles:create",
	RBAC_ROLES_READ: "ox2:rbac roles:read",
	RBAC_ROLES_UPDATE: "ox2:rbac roles:update",
	RBAC_ROLES_DELETE: "ox2:rbac roles:delete",
	RBAC_PERMISSIONS_CREATE: "ox2:rbac permissions:create",
	RBAC_PERMISSIONS_READ: "ox2:rbac permissions:read",
	RBAC_PERMISSIONS_UPDATE: "ox2:rbac permissions:update",
	RBAC_PERMISSIONS_DELETE: "ox2:rbac permissions:delete",
	RBAC_USERS_CREATE: "ox2:rbac users:create",
	RBAC_USERS_READ: "ox2:rbac users:read",
	RBAC_USERS_UPDATE: "ox2:rbac users:update",
	RBAC_USERS_DELETE: "ox2:rbac users:delete",
	GEOLOCATION: "ox2:geolocation",
	ODOO_ORDERS: "krummy capture:odoo orders",
	PROJECT_CHAT: "krummy capture:project chat",
	DROPBOX_ACCESS: "krummy capture:dropbox access",
	MOVE_TO_SIQ_BUTTON: "krummy capture:move to siq button",
	UPDATE_TEMPLATE_BUTTON: "krummy capture:update template button",
	SHOW_PROJECT_NAV: "krummy capture:show project nav",
	CAN_CLOCK_IN_AND_OUT: "krummy capture:can clock in and out",
	CAN_CHANGE_STAGES_BUTTON: "krummy capture:can change stages button",
	CAN_EDIT_PROJECT_FIELD: "krummy capture:can edit project field",
	HAS_SCHEDULE: "krummy capture:has schedule",
	IMPORT_MONITOR_METER_MEASURE_DATA: "ox2:import monitor meter measure data",
	PUBLIC_LINK: "krummy capture:public link",
	OX2_FORECASTING: "ox2:ox2 forecasting",
	CAN_EXPORT: "krummy capture:can export",
	SCHEDULE_DRAFT: "ox2:schedule draft",
	SEE_ALL_LOGS: "ox2:see all logs",
	SEE_APP_STATISTICS: "ox2:see app statistics",
	PORTAL_ACCESS_MANAGEMENT: "ox2:portal access management",
	ADD_EDIT_SCHEDULE: "ox2:add/edit schedule",
	DELETE_FROM_SCHEDULE: "ox2:delete from schedule",
	SEE_DELETED_MESSAGES: "ox2:see deleted messages",
	AI_TEMPLATE_PROMPTING: "krummy capture:ai template prompting",
};

export default PermissionsMap;
